/**
 * 系统管理  公司管理
 */
<template>
  <div class="ph-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <!-- <el-breadcrumb-item>公司管理</el-breadcrumb-item> -->
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.business_name" placeholder="请输入企业名称" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <el-button size="small" type="primary" icon="el-icon-folder-add" title="批量导入企业信息" @click="handleImport()">导入</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-folder-remove" title="批量导出勾选的企业信息" @click="exportCheck()">导出</el-button> -->
        <!-- <el-button size="small" type="danger" icon="el-icon-delete" title="批量删除勾选的企业信息" @click="delCheck()">删除</el-button> -->
      </el-form-item>
      <span style="float: right;font-size: 14px;line-height: 40px;">搜索结果：<span style="color: #F56C6C;">{{ searchTotal }}条</span></span>
    </el-form>
    <div style="display: flex;font-size: 1rem;">
      <div class="search-sidebar" v-if="isRefresh">
        <div v-if="ifCollapseOperate">
          <div v-for="(item,index) in collapseOperate" :key="index" style="border:1px solid  #a9d5de;margin: 12px;padding: 15px;background-color: #F8FFFF;display: flex;">
            <div>
              <span style="color: #276F86;">{{ item.event }}</span>
              <span>{{ item.type }}</span>
              <span style="color: #276F86;">({{ item.value }})</span>
            </div>
            <i class="el-dialog__close el-icon el-icon-close" style="cursor: pointer;" @click="delCollapseOperate(index)"></i>
          </div>
        </div>
        <el-collapse style="border: 0px;">
          <div @click="collapseOperateStatus">
            <el-collapse-item title="经营状态" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseStatusLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseStatusCheckList">
                    <el-checkbox v-for="item in collapseOperateStatusArr" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="operateStatusFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="operateStatusPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>
          <div @click="collapseOperatePerson">
            <el-collapse-item title="人员规模" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapsePersonLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapsePersonCheckList">
                    <el-checkbox v-for="item in collapseOperatePersonArr" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="operatePersonFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="operatePersonPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>
          <div @click="collapseOperateInsured">
            <el-collapse-item title="参保人数" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseInsuredLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseInsuredCheckList" class="applicantGroup">
                    <el-checkbox v-for="item in collapseOperateInsuredArr" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="operateInsuredFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="operateInsuredPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>
          <div @click="collapseOperateType">
            <el-collapse-item title="企业类型" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseTypeLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList" class="applicantGroup">
                    <el-checkbox v-for="item in collapseOperateTypeArr" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="operateTypeFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="operateTypePerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>
          <div @click="collapseOperateIndustry">
            <el-collapse-item title="所属行业" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseIndustryLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseIndustryCheckList" class="applicantGroup">
                    <el-checkbox v-for="item in collapseOperateIndustryArr" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="operateIndustryFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="operateIndustryPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>
        </el-collapse>

      </div>
    <!-- 企业信息展示列表-改版 -->
      <div style="margin-left: 15px;width: 90%;border: solid #EBEEF5 1px;padding: 10px 10px;font-size: 14px;border-radius: 5px;">
          <!-- <div v-for="(item, i) in listData" :key="item.id" style="border-bottom: solid #EBEEF5 1px;padding-bottom: 10px;"> -->
          <div v-for="(item, i) in listData" :key="item.id" style="padding-bottom: 15px;">
            <div class="top-title">
              <!-- <input type="checkbox" id="{{item.id}}"> -->
              <span style="color: #000000DE;">{{ (pageparm.currentPage - 1) * pageparm.pageSize + i + 1 }}.</span>
              <span class="item-name">{{ item.business_name }}</span>
              <!-- <span class="tag" v-for="tag in item.tags" :key="tag">{{ tag }}</span> -->
              <el-tag size="small" v-for="tag in item.tags" :key="tag" style="margin-left: 10px;">{{ tag }}</el-tag>

              <!-- <span style="float: right;margin-left: 10px;"> -->
              <!-- <i class="el-icon-delete" style="cursor: pointer;font-size: 16px;color: #F56C6C;float: right;margin-left: 10px;" title="删除企业所有信息,包含专利商标等"></i> -->
              <!-- </span> -->
              <span style="float: right;">
                <i class="el-icon-refresh" style="cursor: pointer;font-size: 16px;color: #0084FF;" title="手动刷新企业工商信息" @click="updBusiness(item.id,i)"></i>
                &nbsp;&nbsp;{{ item.base_time }}更新&nbsp;&nbsp;
                <i class="el-icon-edit" style="cursor: pointer;font-size: 16px;color: #0084FF;" title="编辑企业" @click="handleEdit(i,item)"></i>&nbsp;&nbsp;
                <i class="el-icon-delete" style="cursor: pointer;font-size: 16px;color: #0084FF;" title="删除企业" @click="deleteBusiness(i,item)"></i>
              </span>
            </div>

            <div class="content-item">
              <div class="content-item-tag">
                <span class="tag-item">法定代表人</span>
                <span class="tag-item2">{{ item.legalPersonName }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">经营状态</span>
                <span class="tag-item2">{{ item.regStatus }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">成立日期</span>
                <span class="tag-item2">{{ item.estiblishTime }}</span>
                <!-- <span style="margin-left: auto;margin-right: 10px;">展开</span> -->
              </div>
            </div>
            <el-collapse style="border: solid #EBEEF5 1px;">
            <el-collapse-item title="详细信息" style="margin-left: 5px;">
            <div class="content-item">
              <div class="content-item-tag">
                <span class="tag-item">注册资本</span>
                <span class="tag-item2">{{ item.regCapital }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">实缴资本</span>
                <span class="tag-item2">{{ item.actualCapital }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">工商注册号</span>
                <span class="tag-item2">{{ item.regNumber }}</span>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-tag">
                <span class="tag-item">统一社会信用代码</span>
                <span class="tag-item2">{{ item.creditCode }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">纳税人识别号</span>
                <span class="tag-item2">{{ item.taxNumber }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">组织机构代码</span>
                <span class="tag-item2">{{ item.orgNumber }}</span>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-tag">
                <span class="tag-item">营业期限</span>
                <span class="tag-item2">{{ item.fromTime }}&nbsp;至&nbsp;{{ item.toTime }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">核准日期</span>
                <span class="tag-item2">{{ item.approvedTime }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">企业类型</span>
                <span class="tag-item2">{{ item.companyOrgType }}</span>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-tag">
                <span class="tag-item">行业</span>
                <span class="tag-item2">{{ item.industry }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">人员规模</span>
                <span class="tag-item2">{{ item.staffNumRange }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">参保人数</span>
                <span class="tag-item2">{{ item.socialStaffNum }}</span>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-tag">
                <span class="tag-item">登记机关</span>
                <span class="tag-item2">{{ item.regInstitute }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">曾用名</span>
                <span class="tag-item2">{{ item.historyNames }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">英文名称</span>
                <span class="tag-item2">{{ item.property3 }}</span>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-tag">
                <span class="tag-item">注册地址</span>
                <span class="tag-item2">{{ item.regLocation }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">企业联系人</span>
                <span class="tag-item2">{{ item.username }}</span>
              </div>
              <div class="content-item-tag">
                <span class="tag-item">联系方式</span>
                <span class="tag-item2">{{ item.mobile }}</span>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-tag2">
                <span class="tag-item">经营范围</span>
                <span :title="item.businessScope" class="tag-item3">{{ item.businessScope }}</span>
              </div>
            </div>
            </el-collapse-item>
            </el-collapse>
          </div>
      </div>
    </div>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="企业名称" prop="business_name">
          <el-input size="small" v-model="editForm.business_name" auto-complete="off" placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="企业税号" prop="business_ein">
          <el-input size="small" v-model="editForm.business_ein" auto-complete="off" placeholder="请输入企业税号"></el-input>
        </el-form-item> -->
        <el-form-item label="企业负责人" prop="username">
          <el-input size="small" v-model="editForm.username" auto-complete="off" placeholder="请输入企业负责人"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="mobile">
          <el-input size="small" v-model="editForm.mobile" auto-complete="off" placeholder="请输入联系方式"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 企业信息导入界面 -->
     <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="importFormVisible" width="50%" @click="closeDialog('importForm')">
        <el-form label-width="120px">
          <el-row>
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M<button @click="downloadImport()" style="margin-left: 15px;cursor: pointer">下载模板</button></div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { 
  getBusinessList, 
  editBusiness, 
  delBusiness,
  webUrl, 
  updateBusiness,
  getBusinessStatusGroup,
  getBusinessFilter,
  getBusinessPersonGroup,
  getBusinessInsuredGroup,
  getBusinessTypeGroup,
  getBusinessIndustryGroup,
  getImportTemplate } from '../../api/patentMG'
import { checkLogin } from '../../utils/util'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      importFormVisible: false, //控制导入页面显示与隐藏
      isRefresh: true,//左侧是否需要刷新
      collapseOperateApi: [],//折叠面板筛选或过滤事件传递值
      collapseOperate: [],// 折叠面板筛选或过滤事件
      ifCollapseOperate: false,// 折叠面板筛选或过滤事件是否存在
      ifCollapseOperateStatus: true,// 折叠面板企业经营状态是否需要查询
      collapseStatusLoading: true,// 折叠面板企业经营状态是否显示加载
      collapseOperateStatusArr: [],// 折叠面板企业经营状态筛选数据
      collapseStatusCheckList: [],// 折叠面板企业经营状态勾选数据
      ifCollapseOperatePerson: true,// 折叠面板企业人员规模是否需要查询
      collapsePersonLoading: true,// 折叠面板企业人员规模是否显示加载
      collapseOperatePersonArr: [],// 折叠面板企业人员规模筛选数据
      collapsePersonCheckList: [],// 折叠面板企业人员规模勾选数据
      ifCollapseOperateInsured: true,// 折叠面板企业参保人数是否需要查询
      collapseInsuredLoading: true,// 折叠面板企业参保人数是否显示加载
      collapseOperateInsuredArr: [],// 折叠面板企业参保人数筛选数据
      collapseInsuredCheckList: [],// 折叠面板企业参保人数勾选数据
      ifCollapseOperateType: true,// 折叠面板企业类型是否需要查询
      collapseTypeLoading: true,// 折叠面板企业类型是否显示加载
      collapseOperateTypeArr: [],// 折叠面板企业类型筛选数据
      collapseTypeCheckList: [],// 折叠面板企业类型勾选数据
      ifCollapseOperateIndustry: true,// 折叠面板企业所属行业是否需要查询
      collapseIndustryLoading: true,// 折叠面板企业所属行业是否显示加载
      collapseOperateIndustryArr: [],// 折叠面板企业所属行业筛选数据
      collapseIndustryCheckList: [],// 折叠面板企业所属行业勾选数据
      title: '添加',
      multipleSelection: [],
      searchTotal: 0, //搜索结果总数量
      editForm: {
        id: '',
        business_name: '',
        // business_ein: '',
        username: '',
        mobile: ''
      },
      idList: [],
      // rules表单验证
      rules: {
        business_name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
      },
      formInline: {
        page: 1,
        ps: 10,
        business_name: ''
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/patent/business/importBusiness',
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.importFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/monitor/importPatMonitor',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      getBusinessList(this.formInline)
      .then(res=>{
          if(res.code == 200){
              this.loading = false
              this.listData = res.data.dataList
               // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getFilter()
      this.isRefresh = true
      this.ifCollapseOperate = true
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.business_name = row.business_name
        this.editForm.username = row.username
        this.editForm.mobile = row.mobile
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.business_name = ''
        this.editForm.username = ''
        this.editForm.mobile = ''
      }
    },
     //显示导入界面
    handleImport: function(index, row) {
      this.title = '企业信息导入'
      this.importFormVisible = true
    },

    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 更新企业工商信息
    updBusiness(business_id,index){
      this.$confirm('确定更新企业信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        updateBusiness({business_id: business_id})
        .then(res=>{
          if(res.code == 200){
            this.listData[index] = res.data
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '取消更新'
          })
        })
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          editBusiness(this.editForm)
            .then(res => {
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              this.editFormVisible = false
              this.loading = false
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('系统错误,请稍后再试!')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteBusiness(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delBusiness({id:row.id})
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('系统错误,请稍后再试!')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 下载企业信息导入模板
    downloadImport() {
     getImportTemplate()
     .then(res=>{
        if(res.code == 200){
          window.location.href = res.data.value
        }else{
          this.$message({
            type: 'error',
            message: '模板下载失败,请稍后再试!'
          })
        }
     })
    },
    // 批量导出勾选的企业
    exportCheck() {
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何数据'
          })
          return false;
      }

    },
    // 批量删除勾选的企业
    delCheck() {
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何数据'
          })
          return false;
      }
      
    },
    // 删除筛选或过滤项
    delCollapseOperate(index){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      collapseOperate.splice(index,1)
      collapseOperateApi.splice(index,1)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      if(this.collapseOperate.length <= 0){
        this.ifCollapseOperate = false
      }
      console.log(this.collapseOperate)
      // 执行删除后的操作
      // 查询筛选条件
      this.getFilter()
    },
    // 经营状态筛选
    operateStatusFilter(){
      let checkList = this.collapseStatusCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '经营状态',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'regStatus',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '经营状态',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'regStatus',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseStatusCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 经营状态过滤
    operateStatusPerk(){
      let checkList = this.collapseStatusCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '经营状态',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'regStatus',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '经营状态',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'regStatus',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseStatusCheckList = []
      // 查询过滤条件
      this.getFilterData()
    },
    // 人员规模筛选
    operatePersonFilter(){
      let checkList = this.collapsePersonCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '人员规模',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'staffNumRange',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '人员规模',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'staffNumRange',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapsePersonCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 人员规模过滤
    operatePersonPerk(){
      let checkList = this.collapsePersonCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '人员规模',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'staffNumRange',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '人员规模',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'staffNumRange',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapsePersonCheckList = []
      // 查询过滤条件
      this.getFilterData()
    },
    // 参保人数筛选
    operateInsuredFilter(){
      let checkList = this.collapseInsuredCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '参保人数',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'socialStaffNum',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '参保人数',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'socialStaffNum',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseInsuredCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 参保人数过滤
    operateInsuredPerk(){
      let checkList = this.collapseInsuredCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '参保人数',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'socialStaffNum',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '参保人数',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'socialStaffNum',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseInsuredCheckList = []
      // 查询过滤条件
      this.getFilterData()
    },
    // 企业类型筛选
    operateTypeFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '企业类型',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'companyOrgType',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '企业类型',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'companyOrgType',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 企业类型过滤
    operateTypePerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '企业类型',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'companyOrgType',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '企业类型',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'companyOrgType',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询过滤条件
      this.getFilterData()
    },
    // 企业所属行业筛选
    operateIndustryFilter(){
      let checkList = this.collapseIndustryCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '所属行业',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'industry',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '所属行业',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'industry',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseIndustryCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 企业所属行业过滤
    operateIndustryPerk(){
      let checkList = this.collapseIndustryCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '所属行业',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'industry',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '所属行业',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'industry',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseIndustryCheckList = []
      // 查询过滤条件
      this.getFilterData()
    },
     // 点击获取折叠面板经营状态数据
    collapseOperateStatus(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapseOperateStatus
      let that = this
      let parameter = that.formInline
      parameter.operateApi = JSON.stringify(that.collapseOperateApi)
      if(isSearch){
        getBusinessStatusGroup(parameter)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
             that.collapseOperateStatusArr = res.data
             that.collapseStatusLoading = false
             that.ifCollapseOperateStatus = false
          }
        })
      }
    },
    // 商标列表(filter模式)
    getFilter(){
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      getBusinessFilter(parameter)
       .then(res => {
        this.loading = false
        if(res.code == 200){
          this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
        }else{
          this.$message({
              type: 'info',
              message: res.msg
            })
        }
      })
      .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
      })
    },
    // 左侧筛选或过滤查询
    getFilterData(){
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      getBusinessFilter(parameter)
       .then(res => {
        this.loading = false
        if(res.code == 200){
          this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
        }else{
          this.$message({
              type: 'info',
              message: res.msg
            })
        }
      })
      .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
      })
    },
    // 点击获取折叠面板人员规模数据
    collapseOperatePerson(){
     // 判断是否需要重新查询
      let isSearch = this.ifCollapseOperatePerson
      let that = this
      let parameter = that.formInline
      parameter.operateApi = JSON.stringify(that.collapseOperateApi)
      if(isSearch){
        getBusinessPersonGroup(parameter)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
             that.collapseOperatePersonArr = res.data
             that.collapsePersonLoading = false
             that.ifCollapseOperatePerson = false
          }
        })
      }
    },
    // 点击获取折叠面板参保人数数据
    collapseOperateInsured(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapseOperatePerson
      let that = this
      let parameter = that.formInline
      parameter.operateApi = JSON.stringify(that.collapseOperateApi)
      if(isSearch){
        getBusinessInsuredGroup(parameter)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
             that.collapseOperateInsuredArr = res.data
             that.collapseInsuredLoading = false
             that.ifCollapseOperateInsured = false
          }
        })
      }
    },
    // 点击获取折叠面板企业类型数据
    collapseOperateType(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapseOperateType
      let that = this
      let parameter = that.formInline
      parameter.operateApi = JSON.stringify(that.collapseOperateApi)
      if(isSearch){
        getBusinessTypeGroup(parameter)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
             that.collapseOperateTypeArr = res.data
             that.collapseTypeLoading = false
             that.ifCollapseOperateType = false
          }
        })
      }
    },
    // 点击获取折叠面板企业所属行业数据
    collapseOperateIndustry(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapseOperateIndustry
      let that = this
      let parameter = that.formInline
      parameter.operateApi = JSON.stringify(that.collapseOperateApi)
      if(isSearch){
        getBusinessIndustryGroup(parameter)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
             that.collapseOperateIndustryArr = res.data
             that.collapseIndustryLoading = false
             that.ifCollapseOperateIndustry = false
          }
        })
      }
    },
     //局部刷新
    reload () {
			this.isRefresh = false;
			this.$nextTick(() => {
				this.isRefresh = true
        this.ifCollapseOperateStatus = true
        this.collapseStatusLoading = true
        this.ifCollapseOperatePerson = true
        this.collapsePersonLoading = true
        this.ifCollapseOperateInsured = true
        this.collapseInsuredLoading = true
        this.ifCollapseOperateType = true
        this.collapseTypeLoading = true
        this.ifCollapseOperateIndustry = true
        this.collapseIndustryLoading = true
			})
		},
    // 关闭编辑、增加弹出框
    closeDialog(name) {
      if(name == 'editForm'){
        this.editFormVisible = false
      }else if(name == 'importForm'){
        this.importFormVisible = false
      }
      
    }
  }
}
</script>

<style scoped>
.ph-container {
  margin: 0 auto;
  max-width: 1680px;
  min-width: 1024px;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.top-title {
  padding-bottom: 10px;
}
.content-item {
  /* margin-top: 5px; */
  display: flex;
  border-top: solid #EBEEF5 1px;
  
}
.content-item-tag {
  width: 33.3%;

}
.item-name {
  color: #000;
  font-size: 16px;
  font-weight: 500;
}
.tag {
  padding: 2px 5px;
  color: #0084FF;
  background: #EBF5FF;
  border-radius: 2px;
  margin-right: 5px;
  font-size: 12px;
}
.label {
  min-width: 148px;
  background: #e4eef6;
  padding: 8px 0px;
  vertical-align: middle;
}
.tag-item {
  width: 148px;
  display: inline-block;
  background: #f0f7fc;
  padding: 8px;
}
.tag-item2 {
  width: calc(100% - 148px);
}
.tag-item3 {
  width: calc(100% - 170px);
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 4px;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.content-item-tag2 {
  width: 100%;
  display: flex;
}
.search-sidebar {
  width: 10%;
  border: solid 1px #EBEEF5;
  /* margin-left: 15px; */
  min-width: 200px;
  font-size: 14px;
}
.search-sidebar .item {
  display: block;
  font-weight: 400;
  margin: 15px 10px;
}
.filter_btn {
  color: #21BA45;
  border: solid 1px #21BA45;
  padding: 6px 6px;
}
.perk_btn {
  color: #DB2828;
  border: solid 1px #DB2828;
  padding: 6px 6px;
}
.patentInfoBase .el-form-item{
  margin-bottom: 0px;
}
.search-sidebar .el-collapse {
  border-bottom: 0px solid #EBEEF5;;
}
.leftCheckbox >>>.el-checkbox__input {
  position: absolute;
  top: 2px;
  left: 0;
}
.leftCheckbox >>>.el-checkbox__label {
  min-width: 130px;
  max-width: 160px;
  display: inline-block;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 19px;
  font-size: 14px;
  padding-left: 20px;
}
.content-item {
  margin-bottom: 2px;
}
.content-label {
  color: #808080;
}
ul {
  list-style: none;
  margin-left: -20px;
  font-size: 12px;
  line-height: 2;
}
.patent-info-column {
  width: 100px;
  display: inline-block;
}
.patent-info-number {
  width: 200px;
  display: inline-block;
}
/* .searchTable > tr {
  height: 40px;
} */
.searchTable .label {
  width: 80px;
  min-width: 80px;
}
.searchTable .select {
  width: 350px;
  min-width: 350px;
}
.searchTable .el-form-item {
  margin-bottom: 5px;
}
.searchTable >>>.el-form-item__label {
  font-weight: 600;
}
.searchTable >>>.el-form-item__content {
  line-height: 20px;
}
.el-dialog-div {
  height: 60vh;
  overflow-x: hidden;
}
.legalContent {
  border: solid 1px #b3b1b1;
  padding: 5px 5px;
  border-radius: 5px;
}
.applicantGroup {
  max-height: 450px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.applicantGroup::-webkit-scrollbar {
    width: 4px;
  }
.applicantGroup::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  /* background: fade(#409EFF, 60%); */
}
.applicantGroup::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  /* background: fade(@primary-color, 30%); */
}
.modal-table {
    color: #333;
    font-size: 14px;
    max-width: 100%;
    text-align: left;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
}
.modal-table.-striped-col {
    text-align: left;
}
.modal-table.-striped-col td:nth-child(odd) {
    background-color: #f0f7fc;
}
.modal-table.-striped-col td {
    border: 1px solid #e4eef6;
    font-weight: 400;
    line-height: 1.57143;
    padding: 8px;
    vertical-align: middle;
}
.markDialog {
  max-height: 700px;
  min-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.markDialog::-webkit-scrollbar {
    width: 4px;
  }
.markDialog::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  /* background: fade(#409EFF, 60%); */
}
.markDialog::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  /* background: fade(@primary-color, 30%); */
}
</style>

 


// WEBPACK FOOTER //
// src/views/company/business.vue